<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.MGM活动编辑") }}</span>
    </div>

    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isEditMode && !isInit">
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont">&#xe618;</i>
              {{ $t("message.修改") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isInit">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
      </div>
    </div>

    <div class="grid-content subtitle">
      <span>{{ $t("message.活动海报编辑") }}</span>
    </div>
    <div class="grid-content content-margin">
      <table class="simpleRow">
        <tr v-if="mgm.mgmid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.活动ID") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="mgm.mgmid"
              readonly
              size="mini"
              placeholder=""
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.活动名称") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              v-model="mgm.name"
              size="mini"
              placeholder=""
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.活动备注") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              v-model="mgm.remarks"
              size="mini"
              placeholder=""
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.状态") }}</span>
          </td>
          <td>
            <el-radio-group
              :disabled="!isEditMode"
              v-model="mgm.state"
              size="mini"
            >
              <el-radio :label="0">{{ $t("message.正常") }}</el-radio>
              <el-radio :label="1">{{ $t("message.禁用") }}</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.背景图片") }}</span>
          </td>
          <td>
            <!-- 图片库控件 -->
            <div
              :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'"
              @click="doShowResourceStore(1)"
            >
              <i class="iconfont" v-if="!mgm.background">&#xe727;</i>
              <el-popover placement="right" trigger="hover" v-else>
                <img
                  :src="mgm.background"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img slot="reference" :src="mgm.background" />
                <el-button
                  v-if="isEditMode"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native="mgm.background = ''"
                ></el-button>
              </el-popover>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">banner图片</span>
          </td>
          <td>
            <!-- 图片库控件 -->
            <div
              :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'"
              @click="doShowResourceStore(3)"
            >
              <i class="iconfont" v-if="!mgm.banner">&#xe727;</i>
              <el-popover placement="right" trigger="hover" v-else>
                <img
                  :src="mgm.banner"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img slot="reference" :src="mgm.banner" />
                <el-button
                  v-if="isEditMode"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native="mgm.banner = ''"
                ></el-button>
              </el-popover>
            </div>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">奖励链接</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              v-model="mgm.rewardurl"
              size="mini"
              placeholder=""
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">奖励跳转类型</span>
          </td>
          <td >
            <el-select  v-model="mgm.rewardjumptype" placeholder="请选择跳转类型"  :disabled="!isEditMode">
              <el-option v-for="(it,index) in selectarr" :key="index" :label="it.key" :value="it.value">
              </el-option>
            </el-select>
          </td>
        </tr>

        <!--
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.参加条件") }}</span>
          </td>
          <td>
            <el-button
              @click="onShowDataSorce"
              :disabled="!isEditMode"
              type="primary"
              size="mini"
              >设置表达式</el-button
            >
            <el-button
              @click="clearDataSource"
              :disabled="!isEditMode"
              type="danger"
              size="mini"
              >清除</el-button
            >
          </td>
        </tr>
        -->

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.积分分组") }}</span>
          </td>
          <td>
            <el-select
              :disabled="!isEditMode"
              size="small"
              v-model="mgm.pointgroupid"
              :placeholder="$t('message.请选择')"
              style="width: 175px"
            >
              <el-option
                v-for="item in pointGroupList"
                :key="item.groupid"
                :label="item.name"
                :value="item.groupid"
              >
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.获取积分") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              v-model="mgm.point"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.开始日期") }}</span>
          </td>
          <td>
            <el-date-picker
              :disabled="!isEditMode"
              v-model="mgm.fromdate"
              type="date"
              placeholder="选择日期"
              clearable
              size="mini"
              style="width: 175px"
            >
            </el-date-picker>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.结束日期") }}</span>
          </td>
          <td>
            <el-date-picker
              :disabled="!isEditMode"
              v-model="mgm.todate"
              type="date"
              placeholder="选择日期"
              clearable
              size="mini"
              style="width: 175px"
            >
            </el-date-picker>
          </td>
        </tr>

        <tr>
          <td style="vertical-align: top;">
            <span class="simpleLabel" style="">{{ $t("message.规则详情") }}</span>
          </td>
          <td>
            <wangeditor @savereturn='saveRule' :init='initRuleDate()' :geteditor='geteditor' :isedit='isEditMode'>
            </wangeditor >
          </td>
        </tr>

        <tr>
          <td style="vertical-align: top;">
            <span class="simpleLabel" style="">{{ $t("message.奖励详情") }}</span>
          </td>
          <td>
            <wangeditor @savereturn='saveReward' :init='initRewardDate()' :geteditor='geteditorreward' :isedit='isEditMode'>
            </wangeditor >
          </td>
        </tr>

      </table>
    </div>

    <div class="grid-content subtitle">
      <span>{{ $t("message.分享图片生成器编辑") }}</span>
    </div>
    <div class="grid-content content-margin">
      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel" style="width: 75px">{{
              $t("message.背景图片")
            }}</span>
          </td>
          <td>
            <!-- 图片库控件 -->
            <div
              :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'"
              @click="doShowResourceStore(2)"
            >
              <i class="iconfont" v-if="!mgm.invitebackground">&#xe727;</i>
              <el-popover placement="right" trigger="hover" v-else>
                <img
                  :src="mgm.invitebackground"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img slot="reference" :src="mgm.invitebackground" />
                <el-button
                  v-if="isEditMode"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native="mgm.invitebackground = ''"
                ></el-button>
              </el-popover>
            </div>
          </td>
        </tr>
      </table>

      <div style="width: 370px">
        <el-divider></el-divider>
      </div>

      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.激活码大小") }}</span>
          </td>
          <td>
            <el-input-number
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.invitecodesize"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.激活码位置X轴") }}</span>
          </td>
          <td>
            <el-input-number
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.invitecodex"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.激活码位置Y轴") }}</span>
          </td>
          <td>
            <el-input-number
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.invitecodey"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">激活码颜色(RGB)</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.invitecoder"
              placeholder="R"
              style="width: 60px"
            ></el-input>
            <span>:</span>
            <el-input
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.invitecodeg"
              placeholder="G"
              style="width: 60px"
            ></el-input>
            <span>:</span>
            <el-input
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.invitecodeb"
              placeholder="B"
              style="width: 60px"
            ></el-input>
          </td>
        </tr>
      </table>

      <div style="width: 370px">
        <el-divider></el-divider>
      </div>

      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.太阳码大小") }}</span>
          </td>
          <td>
            <el-input-number
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.wxacodesize"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.太阳码位置X轴") }}</span>
          </td>
          <td>
            <el-input-number
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.wxacodex"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.太阳码位置Y轴") }}</span>
          </td>
          <td>
            <el-input-number
              :disabled="!isEditMode"
              :min="0"
              size="mini"
              v-model="mgm.wxacodey"
              :placeholder="$t('message.请输入')"
              style="width: 175px"
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td>
            <el-button @click="onPreview" type="primary" size="mini"
              >预览</el-button
            >
          </td>
        </tr>
      </table>
    </div>

    <shade v-if="showResourceStore > 0">
      <resource-store
        :shadeShow="showResourceStore > 0"
        @onClick="onResourceStoreCallback"
        :appID="mgm.appid"
      ></resource-store>
    </shade>

    <shade v-if="showPreview">
      <img @click="onClosePreview" :src="getPreviewImg()" />
    </shade>

    <shade v-if="showDataSource">
      <div class="shade-chil" v-if="showDataSource">
        <newcontainer
          @out="onExitDataSource"
          @datar="onSubmitDataSorce"
          :datac="datasource"
          :isInit="this.datasource ? false : true"
        ></newcontainer>
      </div>
    </shade>

    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteDataSource">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { topfixfunc } from "@/utils/topFix";
import shade from "@/components/shade/shade";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
import ResourceStore from "@/components/resourceStore/resourceStore";
import newcontainer from "@/pages/test/newcontainer";
import wangeditor from "@/components/wangeditor/wangeditor.vue"

export default {
  name: "mgmDetail",
  components: {
    shade,
    ResourceStore,
    newcontainer,
    wangeditor,
  },
  data() {
    return {
      setRule:null,
      tableHeight: 500,
      pointGroupList: [],

      mgm: {
        appid: 188,
        background: null,
        banner: null,
        rewardurl: null,
        rewardjumptype: 0,
        createdate: null,
        createid: null,
        datasourceid: null,
        editdate: null,
        editid: null,
        invitebackground: null,
        invitecodeb: 0,
        invitecodeg: 0,
        invitecoder: 0,
        invitecodesize: null,
        invitecodex: 0,
        invitecodey: 0,
        mgmid: null,
        name: "",
        point: null,
        pointgroupid: null,
        remarks: "",
        state: 0,
        wxacodesize: 0,
        wxacodex: 0,
        wxacodey: 0,
        rule:"",
        reward:''
      },

      datasource: null,

      selectarr: [{ key: '不跳转', value: 0 }, { key: '外部小程序', value: 1 }, { key: '内部页面', value: 2 }, { key: '第三方链接', value: 3 }, { key: '活动页', value: 4 }],

      createName: "",
      editName: "",
      setreward:null,
      isEditMode: true,
      isInit: true,
      showResourceStore: false,
      showDataSource: false,
      showPreview: false,
      deleteDialogVisible: false,
    };
  },
  mounted: function () {
    // 用来监听el-main滚动事件
    topfixfunc();
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    saveRule(rule) {
      console.log(rule,'rule')

      // console.log(rule)
      if(this.isEditMode)
      {
        this.mgm.rule = rule;
      }
    },
     
    saveReward(reward) {
      console.log(reward,'reward')
      if(this.isEditMode) {
        this.mgm.reward = reward;
      }
    },

    initRewardDate() {
      var body = { html: this.mgm.reward };
      console.log(body);
      return body;
    },

    initRuleDate() {
      var body = { html: this.mgm.rule };
      console.log(body);
      return body;
    },

    onClosePreview() {
      this.showPreview = false;
    },

    onPreview() {
      this.showPreview = true;
    },

    getPreviewImg() {
      return '/rs/mgm/preview?' + this.getPreviewParam();
    },

    getPreviewParam() {
       return "appid=" + this.mgm.appid 
        + "&wxacodesize=" + this.mgm.wxacodesize
        + "&wxacodex=" + this.mgm.wxacodex
        + "&wxacodey=" + this.mgm.wxacodey
        + "&invitebackground=" + this.mgm.invitebackground
        + "&invitecodeb=" + this.mgm.invitecodeb
        + "&invitecodeg=" + this.mgm.invitecodeg
        + "&invitecoder=" + this.mgm.invitecoder
        + "&invitecodesize=" + this.mgm.invitecodesize
        + "&invitecodex=" + this.mgm.invitecodex
        + "&invitecodey=" + this.mgm.invitecodey
        + "&timestamp=" + (+new Date())
    },

    onShowDataSorce() {
      this.showDataSource = true;
    },

    //清空条件表达式
    clearDataSource() {
      this.deleteDialogVisible = true;
    },

    deleteDataSource() {
      this.datasource = null;
      this.deleteDialogVisible = false;
    },

    //退出条件表达式
    onExitDataSource() {
      this.showDataSource = false;
    },

    //提交条件表达式
    onSubmitDataSorce(dataSorce) {
      this.datasource = dataSorce;
      this.showDataSource = false;
    },

    doShowResourceStore(type) {
      if (!this.isEditMode) return;
      this.showResourceStore = type;
    },
    onResourceStoreCallback(doc) {
      console.log(doc);
      if (doc) {
        switch (this.showResourceStore) {
          case 1:
            this.mgm.background = doc.resourceID;
            break;
          case 2:
            this.mgm.invitebackground = doc.resourceID;
            break;
          case 3:
            this.mgm.banner = doc.resourceID;
            break;
        }
        this.showResourceStore = 0;
      } else {
        this.showResourceStore = 0;
      }
    },
    goBack() {
      this.$router.go(-1); //返回上一层
    },

    doSave() {
      this.isEditMode = false;

      var body = { mgm: this.mgm, datasource: this.datasource };
      if (this.isInit) {
        rejecthttp(true, "post", "/manage/mgm/add", body, this, (doc) => {
          changeflagCLOSED(doc, 1, this);
          if (doc.data.Code == "MSGKEY_OK") {
          }
        });
      } else {
        this.mgm.editdate = null;
        this.mgm.editid = null;
        this.mgm.createdate = null;
        this.mgm.createid = null;
        rejecthttp(true, "post", "/manage/mgm/edit", body, this, (doc) => {
          changeflagCLOSED(doc, 1, this);
          if (doc.data.Code == "MSGKEY_OK") {
          }
        });
      }
    },

    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/point/pointgrouplist",
        { appid: "188", search: "" },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            // 添加总条数
            this.pointGroupList = doc.data.data;
          }
          this.getMgmDetial();
        }
      );
    },

    getMgmDetial() {
      if (!this.mgm.mgmid) {
        return;
      }
      this.$http
        .get("/manage/mgm/detail", {
          params: {
            appid: this.mgm.appid,
            mgmid: this.mgm.mgmid,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.mgm = doc.data.data.mgm;
            this.datasource = doc.data.data.datasource;
            this.setRule(this.mgm.rule);
            this.setreward(this.mgm.reward)
          }
        });
    },

    geteditor(setRule){
      this.setRule = setRule;
    },
    geteditorreward(setreward){
      this.setreward=setreward
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },

  created() {
    this.mgm.appid = this.$route.query.appid ? this.$route.query.appid : 0;
    if (this.$route.query.id) {
      this.mgm.mgmid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
  },

  computed: {},
  // // 隐藏固定栏
  // destroyed () {
  //   var topFix=document.querySelector('.topFix')
  //   // 固定栏隐藏
  //   topFix.style.display='none'
  // }
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}

.shade-chil {
  width: 1160px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/mgmdetail.vue